const typeLabels = {
  legislation: "Normativa",
  doctrine: "Doctrina",
  jurisprudence: "Jurisprudencia",
  case_record: "Expediente",
  attachment: "Archivo adjunto",
  library: "Fuente del cuaderno",
};

export function normalizeCitation(citation = {}) {
  const source = citation.source || citation.metadata?.source || {};
  return {
    ...citation,
    type: citation.type || citation.citationType || "source",
    label:
      citation.label ||
      citation.locator ||
      source.title ||
      "Fuente registrada",
    source,
  };
}

export function citationTypeLabel(type) {
  return typeLabels[type] || "Fuente";
}

export function safeSourceUrl(value) {
  if (!value) return null;
  try {
    const url = new URL(value);
    return ["http:", "https:"].includes(url.protocol) ? url.href : null;
  } catch {
    return null;
  }
}
